import { Volume2 } from "lucide-react";

import { FileComponentProps } from "../../types";
import { FileThumbnail } from "../FileThumbnail";
import { FilePreviewWrapper } from "../FilePreviewWrapper";
import { getFileSizeFromBase64 } from "../../utils";

import { AudioPlayer } from "./AudioPlayer";

export const AudioDisplay = ({
  data,
  detectedFile,
  isViewing,
  setIsViewing,
}: FileComponentProps) => {
  let cleanData = data;
  if (cleanData.startsWith("[") && cleanData.endsWith("]")) {
    try {
      const parsed = JSON.parse(cleanData);
      if (Array.isArray(parsed) && parsed.length > 0) {
        cleanData = parsed[0];
      }
    } catch {
      cleanData = cleanData.slice(1, -1).replace(/"/g, "");
    }
  }

  cleanData = cleanData.replace(/^"(.*)"$/, "$1");

  const dataUrl = cleanData.startsWith("data:") ? cleanData : `data:audio/mpeg;base64,${cleanData}`;

  return (
    <div className="group relative">
      <div className="cursor-pointer rounded p-2 transition-colors hover:bg-gray-100">
        <FilePreviewWrapper
          isViewing={isViewing}
          setIsViewing={setIsViewing}
          trigger={
            <div>
              <FileThumbnail
                icon={<Volume2 className="h-6 w-6 text-gray-600" />}
                title="Audio File"
                subtitle={`${
                  detectedFile.extension?.toUpperCase() || "AUDIO"
                } • ${getFileSizeFromBase64(data)}`}
              />
            </div>
          }
        >
          <AudioPlayer dataUrl={dataUrl} />
        </FilePreviewWrapper>
      </div>
    </div>
  );
};
